import React, { useEffect } from "react";
import { Navbar, Footer } from "../components";
// import { Loading } from "../components";

// const currentGuidePath = '/guide/Sept 2026.pdf';

const Guide = () => {
  // useEffect(() => {
  //   window.location = currentGuidePath;
  // }, []);
  return <>
    <Navbar />
    <fs-media-library
      series-id="15712b8b-54b6-4821-8c6f-688709f0fb99"
      show="latest"
      layout="videos"
    ></fs-media-library>
    <Footer />
  </>
}

export default Guide;